<template> 
    <div :class="this.classes()" :style="this.style">
        <slot></slot>
    </div>
</template>
<script>
import { useBEM } from '../../../common/utils/classnames';
let classnames = useBEM( 'hanzo-swipe-item' );
export default {
    name: 'h-swipe-item',
    computed: {
        style() {
            const { vertical, computedWidth, computedHeight } = this.$parent;

            const style = {
            width: computedWidth + 'px',
            height: vertical ? computedHeight + 'px' : '100%',
            transform: `translate${vertical ? 'Y' : 'X'}(${this.offset}px)`
            };
            return style;
        }
    },
    data() {
        return {
            offset: 0
        };
    },

    beforeCreate() {
        this.$parent.swipes.push(this);
    },

    destroyed() {
        this.$parent.swipes.splice(this.$parent.swipes.indexOf(this), 1);
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        }
    }
}
</script>
<style lang="less" scoped>
.hanzo-swipe-item {
  float: left;
  height: 100%;
}
</style>
